import FormContainer from '../components/common/form/FormContainer';

export default function Login() {
  return <FormContainer />;
}
